import { z } from 'zod'

export const promptTemplateDrawerFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Template name is required')
    .max(200, 'Name must be 200 characters or less'),
  description: z.string().max(500, 'Description must be 500 characters or less'),
  content: z.string().min(1, 'Template content is required'),
})

export type PromptTemplateDrawerFormSchemaType = z.infer<typeof promptTemplateDrawerFormSchema>

export const defaultPromptTemplateFormValues: PromptTemplateDrawerFormSchemaType = {
  name: '',
  description: '',
  content: '',
}
